// extracted by mini-css-extract-plugin
module.exports = {"filterLanguage":"style_filterLanguage__1rjci"};